export default __webpack_public_path__ + "static/media/blondal-logo.9af185d7.svg";